import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';
import { ModuleFormValues } from 'src/models/Module.model';
import ATMMultiSelect from 'src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect';
import useChapters from 'src/hooks/useChapters';
import ATMCheckbox from 'src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox';

type Props = {
  formikProps: FormikProps<ModuleFormValues>;
  onClose: () => void;
  formType?: "ADD" | "EDIT";
  setSaveNextChecked?: any;
  saveNextChecked?: any
};

const ModuleForm = ({ formikProps, onClose , formType , saveNextChecked  , setSaveNextChecked }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur  } = formikProps;
  
  const { chapters, isDataLoading: isChapterLoading } = useChapters();
const ChapterOption = chapters?.map((el:any)=>{
  return{
    label :el?.chapterName,
    value:el?._id
  }
})
  return (
    <div className='p-4 flex flex-col gap-4'>
      <div className='flex justify-between items-center'>
        <div className='text-xl font-medium'>{formType === "EDIT" ? "Update  Module" : "Add  Module"}</div>
        <button type='button' className='hover:bg-hover' onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className='flex flex-col gap-4'>
       {/* Module Name */}
       <div >
         <ATMTextField
           name='moduleName'
           value={values?.moduleName}
           onChange={(e) => setFieldValue('moduleName', e.target.value)}
           label='Module Name'
           placeholder='Enter Module Name'
           onBlur={handleBlur}
         />
       </div>
       {/* Chapters */}
       <div>
          <ATMMultiSelect
            name="chapterId"
            value={values.chapterId}
            onChange={(newValue) => setFieldValue("chapterId", newValue)}
            onBlur={handleBlur}
            label="Chapters"
            placeholder="Select Chapters"
            isLoading={isChapterLoading}
            options={ChapterOption}
          />
        </div> 
      </div> 
      {formType === "ADD" && (
        <div>
          <ATMCheckbox
            label="Save and Next"
            checked={saveNextChecked}
            onChange={(checked) => {
              setSaveNextChecked(checked);
            }}
          />
        </div>
      )}
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type='submit'>
          Save
        </ATMLoadingButton>
      </div> 
    </div>
  );
};

export default ModuleForm;